import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=7231894a"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"
import style0 from "./AccountProfile.vue?vue&type=style&index=0&id=7231894a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports